export const namespaced = true;

import FrozenService from '@/services/FrozenService.js';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import {
  basicDatetime,
  basicFrozenType,
  basicSubFieldPresent,
  basicFieldPresent,
  basicFrozenRemainingDays,
} from '@/presenters/fields';

export const state = {
  frozens: [],
  relatedFrozens: [],
};

export const mutations = {
  SET_FROZENS(state, frozens) {
    state.frozens = frozens;
  },
  SET_RELATED_FROZENS(state, relatedFrozens) {
    state.relatedFrozens = relatedFrozens;
  },
  RESTORE_FROZEN() {
    // We only restore Frozen, so we don't need to do anything here
  },
};

export const actions = {
  fetchFrozens({ commit }) {
    return FrozenService.all().then((response) => {
      const frozens = map(response.data, (frozen) => formatFrozen(frozen));
      commit('SET_FROZENS', frozens);
    });
  },
  fetchRelatedFrozens({ commit }, id) {
    return FrozenService.get(id).then((response) => {
      commit('SET_RELATED_FROZENS', response.data.frozenChildren);
    });
  },
  restoreFrozen({ commit }, id) {
    return FrozenService.restoreFrozen(id)
      .then(() => {
        commit('RESTORE_FROZEN');
      })
      .catch(() => {
        throw 'restore frozen fail';
      });
  },
  testScheduledFunction() {
    return FrozenService.testScheduledFunction();
  },
};

export const getters = {
  getFrozenById: (state) => (id) => {
    return state.frozens.find((item) => item.id == id);
  },
  totalFrozens: (state) => {
    return state.frozens.length;
  },
  totalRelatedFrozens: (state) => {
    return state.relatedFrozens.length;
  },
  getExcelFormattedFrozens: (state) => {
    return map(state.frozens, (frozen) => {
      return {
        凍結日: basicDatetime(frozen.frozenDatetime),
        ID種別: basicFrozenType(frozen.type),
        名前: basicFieldPresent(frozen.frozen, 'name'),
        ID: basicFieldPresent(frozen.frozen, 'uid'),
        凍結実行者: isEmpty(frozen.frozenBy.username)
          ? basicFieldPresent(frozen.frozenBy, 'id').toString()
          : basicFieldPresent(frozen.frozenBy, 'username'),
        凍結元ID: isEmpty(frozen.frozenRoot.frozen)
          ? basicFieldPresent(frozen.frozenRoot, 'uid')
          : basicSubFieldPresent(frozen.frozenRoot, 'frozen', 'uid'),
        削除まで: basicFrozenRemainingDays(frozen.frozenDatetime),
      };
    });
  },
  getExcelHeaderFrozens: () => {
    return ['凍結日', 'ID種別', '名前', 'ID', '凍結実行者', '凍結元ID', '削除まで'];
  },
};

const formatFrozen = (frozen) => {
  if (isEmpty(frozen.frozenRoot)) {
    frozen.isFrozenRoot = true;
    frozen.frozenRoot = frozen.frozen;
  }
  return frozen;
};
